const loadScriptFromUrl = (url, isAsync = false, callback) => {
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = isAsync;
  s.src = url;
  const headEle = document.getElementsByTagName('head')[0];
  headEle.appendChild(s);
  s.onload = () => {
    if (callback) callback();
  };
  return s;
};

export default loadScriptFromUrl;
